import { ParsedUrlQuery } from 'querystring';

export const shouldShowRedirectBanner = (query: ParsedUrlQuery) => {
    const { utm_source, utm_medium } = query;

    return utm_source === 'smartnewhomes' && utm_medium === 'referral';
};
